import { Component, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortInactiveVesselsComponent } from './port-inactive-vessels/port-inactive-vessels.component';


@Component({
  selector: 'app-port-home',
  templateUrl: './port-home.component.html',
  styleUrls: ['./port-home.component.scss']
})
export class PortHomeComponent {
selectedTab: boolean = true;
  dashboardData:any;
  @ViewChild('inActive') InActiveVesselComponent!: PortInactiveVesselsComponent;
  constructor(private dashboardService: DashboardService) {
    this.selectedTab = true;
  }

  ngOnInit(): void {
    this.selectedTab = true;
  }
  tabChanged(event: MatTabChangeEvent) {
    this.selectedTab = !this.selectedTab;
    if (this.InActiveVesselComponent) {
      this.InActiveVesselComponent.refresh();
    }
  }
  isDarkMode() {
    // return this.requestFormService.isDarkMode();
  }
}
